import { render, staticRenderFns } from "./NaikinimasFormavimas.vue?vue&type=template&id=46548c17&"
import script from "./NaikinimasFormavimas.vue?vue&type=script&lang=js&"
export * from "./NaikinimasFormavimas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VAlert,VContainer,VDataTable,VFooter})
